export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST'
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS'
export const CREATE_ORDER_FAIL = 'CREATE_ORDER_FAIL'

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST'
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS'
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL'

export const ORDER_PAY_REQUEST = 'ORDER_PAY_REQUEST'
export const ORDER_PAY_SUCCESS = 'ORDER_PAY_SUCCESS'
export const ORDER_PAY_FAIL = 'ORDER_PAY_REQUEST'

export const ORDER_PAY_RESET = 'ORDER_PAY_RESET'

export const UPLOAD_TRIP_REQUEST = "UPLOAD_TRIP_REQUEST"
export const UPLOAD_TRIP_SUCCESS = "UPLOAD_TRIP_SUCCESS"
export const UPLOAD_TRIP_FAIL = "UPLOAD_TRIP_FAIL"

export const ALL_ORDER_REQUEST = "ALL_ORDER_REQUEST"
export const ALL_ORDER_SUCCESS = "ALL_ORDER_SUCCESS"
export const ALL_ORDER_FAIL = "ALL_ORDER_FAIL"

export const CONFIRM_ORDER_REQUEST = "CONFIRM_ORDER_REQUEST"
export const CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS"
export const CONFIRM_ORDER_FAIL = "CONFIRM_ORDER_FAIL"
export const CONFIRM_ORDER_RESET = "CONFIRM_ORDER_RESET"